module.exports = __webpack_public_path__ + "img/implant-how-work.46e0777c.png";